import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {get, isEmpty} from 'lodash';
import classnames from 'classnames';
import i18n from 'i18n';

import * as appActions from 'redux/modules/app';
import {
  fetchChatMembersAsAdvertiser as fetchMembers,
  fetchChatMessagesAsAdvertiser as fetchMessages,
  sendMessageAsAdvertiser as sendMessage,
  setLastReadMessageAsAdvertiser as setLastReadMessage
} from 'redux/modules/chats';

import {getChatMessages, getChat} from 'modules/shared/selectors';

import {ChatTextarea} from 'modules/shared/components';
import {ChatConversation} from 'modules/shared/containers';

const MESSAGES_PER_FETCH = 20;
const DEFAULT_HEIGHT = 'calc(100% - 5.5rem)';

function mapStateToProps(state, {chatId}) {
  return {
    chat: getChat(state, chatId),
    messages: getChatMessages(state, chatId),
    messagesRequest: get(state, `app.requests.fetchChatMessages_${chatId}`)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchMessages,
    fetchMembers,
    sendMessage,
    setLastReadMessage,
    showAlert: appActions.showAlert
  }, dispatch);
}

class ChatWithInfluencer extends Component {
  state = {
    errors: []
  }

  onFetchMembers = () => {
    const {brandId, chatId} = this.props;

    if (!!chatId && !!brandId) {
      this.props.fetchMembers({brandId, chatId});
    }
  }

  onFetchMessages = () => {
    const {brandId, chatId, messages} = this.props;
    const oldestMessageIndex = get(messages, '[0].index');

    if (!!chatId && !!brandId) {
      this.props.fetchMessages({
        brandId,
        chatId,
        limit: MESSAGES_PER_FETCH,
        cursor: oldestMessageIndex
      });
    }
  }

  onSendMessage = ({text, attachments}) => {
    const {brandId, chatId, sendMessage} = this.props;
    const args = {
      text,
      attachments,
      chatId,
      brandId
    };

    return sendMessage(args)
      .catch(this.onSendError);
  }

  onSendError = () => {
    this.props.showAlert({
      type: 'error',
      message: i18n.get('CHAT_SENDING_ERROR')
    });
    return Promise.reject();
  }

  onSetLastReadMessage = (messageId) => {
    const {chatId, brandId} = this.props;
    if (!chatId || !brandId || !messageId) return;

    this.props.setLastReadMessage({messageId, chatId, brandId});
  }

  onErrorsChange = (errors) => {
    this.setState({errors});
  }

  shouldRenderTextarea = () => {
    const {messagesRequest, messages, chat} = this.props;
    const isLoadingMessages = messagesRequest.status === 'loading';
    const hasMessages = !isEmpty(messages);
    const status = get(chat, 'member.chatStatus');

    if (!hasMessages && isLoadingMessages) return false;
    return status !== 'blocked';
  }

  render = () => {
    const {
      chatId,
      messagesRequest,
      className,
      conversationStyle
    } = this.props;
    const isLoadingMessages = messagesRequest.status === 'loading';
    const containerClassName = classnames('col end-xs width100 height100 vf-bg-white-color', className);
    return (
      <div className={containerClassName}>
        <ChatConversation
          chatId={chatId}
          onFetchMembers={this.onFetchMembers}
          onFetchMessages={this.onFetchMessages}
          onSetLastReadMessage={this.onSetLastReadMessage}
          isLoading={isLoadingMessages}
          errors={this.state.errors}
          style={conversationStyle}
        />

        {this.shouldRenderTextarea() && (
          <ChatTextarea
            onSend={this.onSendMessage}
            onErrorsChange={this.onErrorsChange}
          />
        )}
      </div>
    );
  }
}

ChatWithInfluencer.propTypes = {
  chat: PropTypes.object,
  messages: PropTypes.array,
  chatId: PropTypes.string.isRequired,
  brandId: PropTypes.string.isRequired,
  messagesRequest: PropTypes.object,
  fetchMembers: PropTypes.func.isRequired,
  fetchMessages: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  setLastReadMessage: PropTypes.func.isRequired,
  conversationStyle: PropTypes.object,
  className: PropTypes.string,
  showAlert: PropTypes.func.isRequired
};

ChatWithInfluencer.defaultProps = {
  chat: null,
  messages: [],
  messagesRequest: {},
  className: '',
  conversationStyle: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatWithInfluencer);
